// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3kEiF","info":"Note_info__1hRKd","note":"Note_note__39E4R","actions":"Note_actions__1HeCH"};